import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';

export function KnowledgeArticleLink({ slug, className, children }: { slug: string; className?: string; children: ReactNode }) {
  if (slug === 'visibilidad-ia-empresas') return <Link to="/blog/visibilidad-ia-empresas" className={className}>{children}</Link>;
  if (slug === 'atlas-chatgpt-seo-local') return <Link to="/blog/atlas-chatgpt-seo-local" className={className}>{children}</Link>;
  return <Link to="/blog/$slug" params={{ slug }} className={className}>{children}</Link>;
}